'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsFirstVisitorSession = undefined;

var _reselect = require('reselect');

var _getIsFirstVisitorSession = require('../operators/getIsFirstVisitorSession');

var _getVisitorIdentity = require('./getVisitorIdentity');

var getIsFirstVisitorSession = exports.getIsFirstVisitorSession = (0, _reselect.createSelector)(_getVisitorIdentity.getVisitorIdentity, function (visitorIdentity) {
  return (0, _getIsFirstVisitorSession.getIsFirstVisitorSession)(visitorIdentity);
});